import React, {useState, useRef, useEffect} from "react";

const ContactForm = ({service, allServices, formType}) => {
    const [sending, setSending] = useState(false);
    const contactFormRef = useRef(null);
    const fullNameRef = useRef(null);
    const serviceRef = useRef(null);
    const emailRef = useRef(null);
    const telRef = useRef(null);
    const messageRef = useRef(null);

    const [type, setType] = useState('house');

    const validateEmail = (email) => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        let valid = true;

        const fields = [
            {ref: fullNameRef, required: true},
            {ref: emailRef, required: true, validate: validateEmail},
            {ref: serviceRef, required: formType === 'demand'},
            {ref: telRef, required: true},
            {ref: messageRef, required: false},
        ];

        fields.forEach(({ref, required, validate, isCheckbox}) => {
            if (ref.current === null) {
                return;
            }

            ref.current.parentElement.classList.remove('error');

            if (required && (isCheckbox ? !ref.current.checked : ref.current.value === '')) {
                ref.current.parentElement.classList.add('error');
                valid = false;
            } else if (validate && !validate(ref.current.value)) {
                ref.current.parentElement.classList.add('error');
                valid = false;
            }
        });

        if (valid) {
            setSending(true);

            const data = {
                full_name: fullNameRef.current.value,
                email: emailRef.current.value,
                tel: telRef.current.value,
                service: serviceRef.current?.value ?? service,
                message: messageRef.current.value,
                type: formType === 'demand' ? type : null,
                form_type: formType
            }
            const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;


            fetch('/api/contact-form', {
                headers: {
                    "Accept": "application/json",
                    "X-CSRF-Token": csrfToken,
                    "Content-Type": "application/json",
                },
                method: 'POST',
                body: JSON.stringify(data)
            })
                .then(result => result.json())
                .then(data => {
                    const {msg, code} = data;
                    setSending(false);
                    if (code === 1) {
                        window.dataLayer = window.dataLayer || [];
                        if (formType === 'demand') {
                            window.dataLayer.push({
                                event: "contact-form-success-submit",
                                FormService: serviceRef.current?.value ?? service,
                                FormSpace: type
                            });
                        } else {
                            window.dataLayer.push({event: "contact-form-success-submit"});
                        }

                        alert('Podarilo sa úspešne odoslať');
                        contactFormRef.current.reset();

                        document.body.classList.remove('open-contact-form');
                        document.documentElement.removeAttribute('style');
                    } else {
                        alert(msg);
                    }
                });
        }
    };

    return (
        <form method="post" onSubmit={handleSubmit} ref={contactFormRef}>
            <div className="row">
                <div className="form-group col-lg-12">
                    <label htmlFor="name" className="form-label">Meno a priezvisko</label>
                    <input ref={fullNameRef} type="text" name="name" className="form-control" id="name"/>
                    <span className="warning-text">Toto pole je povinné</span>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-lg-6">
                    <label htmlFor="tel" className="form-label">Telefón</label>
                    <input ref={telRef} type="text" className="form-control" name="tel" id="tel"/>
                    <span className="warning-text">Toto pole je povinné</span>
                </div>

                <div className="form-group col-lg-6">
                    <label htmlFor="email" className="form-label">E-mail</label>
                    <input ref={emailRef} type="text" className="form-control" name="email" id="email"/>
                    <span className="warning-text">Zadajte správny tvar emailu</span>
                </div>
            </div>
            {formType === 'demand' && (
                <div className="row">
                    <div className="form-group col-lg-6">
                        <label htmlFor="tel" className="form-label">Vyberte si službu</label>
                        <select
                            defaultValue={service}
                            ref={serviceRef}
                            className="form-control"
                        >
                            <option value="" disabled={true}></option>
                            {allServices.map((_service) => (
                                <option key={'service-' + _service.id} value={_service.id}>{_service.title}</option>
                            ))}
                            <option value="99">Iné</option>
                        </select>
                        <span className="warning-text">Toto pole je povinné</span>
                    </div>

                    <div className="form-group col-lg-6">
                        <span className="form-label">Typ priestoru</span>
                        <div className="d-flex">
                            <button
                                type="button"
                                onClick={() => setType('house')}
                                className={"toggle-btn " + (type === 'house' ? 'active' : '')}>DOM
                            </button>
                            <button
                                type="button"
                                onClick={() => setType('building')}
                                className={"toggle-btn " + (type === 'building' ? 'active' : '')}>BUDOVA
                            </button>
                        </div>
                        <span className="warning-text">Zadajte správny tvar emailu</span>
                    </div>
                </div>
            )}

            <div className="row">
                <div className="form-group col-sm-12 mb-2">
                    <label htmlFor="message" className="form-label">Požiadavky</label>
                    <textarea
                        ref={messageRef}
                        name="message"
                        id="message"
                        className="form-control"
                    ></textarea>
                </div>
            </div>

            <div className="form-group">
                <p className="gdpr-consent">Odoslaním formulára vyhlasujete, že ste sa oboznámili s <a
                    href="/storage/ochrana-osobnych-udajov.pdf" target="_blank">informáciami
                    o spracúvaní osobných údajov.</a></p>
            </div>
            <button
                type="submit"
                className="btn"
                disabled={sending}
            >
                {sending ? "odosielam..." : "odoslať požiadavku"}
            </button>
        </form>
    );
};

export default ContactForm;
